
import React from 'react';


const RightTick = ({ activebackground }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <mask id="mask0_15707_17317" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.704102" width="16" height="15.6098" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15707_17317)">
        <path d="M7.06927 11.4959L11.7693 6.91057L10.8359 6L7.06927 9.6748L5.16927 7.82114L4.23594 8.73171L7.06927 11.4959ZM8.00261 15.0081C7.08039 15.0081 6.21372 14.8374 5.40261 14.4959C4.5915 14.1545 3.88594 13.6911 3.28594 13.1057C2.68594 12.5203 2.21094 11.832 1.86094 11.0407C1.51094 10.2493 1.33594 9.40379 1.33594 8.50407C1.33594 7.60434 1.51094 6.75881 1.86094 5.96748C2.21094 5.17615 2.68594 4.4878 3.28594 3.90244C3.88594 3.31707 4.5915 2.85366 5.40261 2.5122C6.21372 2.17073 7.08039 2 8.00261 2C8.92483 2 9.7915 2.17073 10.6026 2.5122C11.4137 2.85366 12.1193 3.31707 12.7193 3.90244C13.3193 4.4878 13.7943 5.17615 14.1443 5.96748C14.4943 6.75881 14.6693 7.60434 14.6693 8.50407C14.6693 9.40379 14.4943 10.2493 14.1443 11.0407C13.7943 11.832 13.3193 12.5203 12.7193 13.1057C12.1193 13.6911 11.4137 14.1545 10.6026 14.4959C9.7915 14.8374 8.92483 15.0081 8.00261 15.0081Z" fill="currentColor" className={activebackground} />
      </g>
    </svg>
  );
};
export default RightTick;
